<template>
  <div v-loading="loader">
    <div class="nav-bar" >
      <div class="nav-bar__tabs tabs">
        <div class="tabs__item">
          <router-link class="tabs__link"
             :to="`/transactions/${$route.params.id}/tx/1`"
          >Transaction</router-link>
        </div>
        <div class="tabs__item">
          <router-link class="tabs__link tabs__link--active"
                       :to="`/transactions/${$route.params.id}/holders/1`"
          >Holders</router-link>
        </div>
      </div>
      <div class="nav-bar__pages page">
        <router-link class="page__first" :to="get_first">Last</router-link>
        <router-link class="page__prev" :to="get_prev">&lt;</router-link>
        <span class="page__current"><b>{{$route.params.num}}</b> of {{max_page}}</span>
        <router-link class="page__next" :to="get_next">&gt;</router-link>
        <router-link class="page__last" :to="get_last">Last</router-link>
      </div>
      <form class="nav-bar__form-search" action="" method="GET">
        <input v-model="search_txt" name="search-token" placeholder="Search" type="search">
        <button type="submit">
          <img :src="search" alt="Search">
        </button>
      </form>
    </div>
    <div class="table-holders"  v-if="!loader">
      <div class="table-holders__header holders">
        <div class="holders__num">
          Number
        </div>
        <div class="holders__address">
          Address
        </div>
        <div class="holders__last-activity">
          Last activity
        </div>
        <div class="holders__balance">
          Balance
        </div>
        <div class="holders__info">
          Info
        </div>
      </div>
      <div class="table-holders__item holders" v-for="(table, index) in data_table">
        <div class="holders__num">
          <div class="holders__num-name">
            Number
          </div>
          <div class="holders__num-value">
            {{indexMethod(index)}}
          </div>timeStamp
        </div>
        <div class="holders__address">
          <div class="holders__address-name">
            Address
          </div>
          <div class="holders__address-value">
            <router-link :to="'/address/' + table.address + '/tx/1'">{{table.address}}</router-link>
          </div>
        </div>
        <div class="holders__last-activity">
          <div class="holders__last-activity-name">
            Last activity
          </div>
          <div class="holders__last-activity-value">
            {{table.lastActivity}}
          </div>
        </div>
        <div class="holders__balance">
          <div class="holders__balance-name">
            Balance
          </div>
          <div class="holders__balance-value">
            {{divisibility(table.quantity, table.div)}}
          </div>
        </div>
        <div class="holders__info">
          <div class="holders__info-name">
            Info
          </div>
          <div class="holders__info-value">
            {{table.info}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MosaicProxy from '../../../proxies/MosaicProxy';
  import moment from 'moment';
  import { createNamespacedHelpers } from 'vuex';
  import { divisibility } from '../../../utils/Math_util';
  import search from './../../../assets/images/icon/search.svg';

  const { mapState, mapActions } = createNamespacedHelpers('core');

  export default {
    props: ['txCount'],
    name: 'TableHolders',
    async mounted() {
      this.get_data(this.$route.params.num);
    },

    computed: {
      data_table() {
        return  this.tableData.filter(data => !this.search_txt
          || data.address.toLowerCase().includes(this.search_txt.toLowerCase())
        )
      },
      ...mapState(['detail']),
      max_page() {
        return Math.ceil(Number(this.detail.rich) / 50);
      },
      get_prev() {
        const prev = Number(this.$route.params.num) - 1;
        if (prev < 1) {
          return `/transactions/${this.$route.params.id}/holders/1`;
        }
        return `/transactions/${this.$route.params.id}/holders/${prev}`;
      },
      get_next() {
        const next = Number(this.$route.params.num) + 1;
        if (next > this.max_page) {
          return `/transactions/${this.$route.params.id}/holders/${this.max_page}`;
        }
        return `/transactions/${this.$route.params.id}/holders/${next}`;
      },
      get_last() {
        return `/transactions/${this.$route.params.id}/holders/${this.max_page}`;
      },
      get_first() {
        return `/transactions/${this.$route.params.id}/holders/1`;
      }
    },
    watch: {
      '$route' (to, from) {
        this.get_data(this.$route.params.num);
      }
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
      indexMethod(index) {
        return ((this.$route.params.num - 1) * 50) + index + 1;
      },
      async tx_route(current) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        this.$router.push({
          name: 'tx.holders',
          params: { num: current }
        });
        await this.get_data(current);
        loading.close();
      },
      async get_data(page) {
        const mosaics_proxy = new MosaicProxy();
        const info_response = await mosaics_proxy.get_info();
        const info = info_response.data;
        try {

          const response = await mosaics_proxy.get_mosaic_rich_list(this.$route.params.id, page);
          const nemEpoch = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
          response.forEach((data) => {
            const txTimestamp = new Date(nemEpoch + (data.lastActivity * 1000));
            let info_txt = info[data.address] === undefined ? '-' : info[data.address];

            if (data.quantity) {
              this.tableData.push({
                ...data,
                info: info_txt,
                txTimestamp: txTimestamp,
                lastActivity: data.lastActivity !== null ? moment(txTimestamp)
                  .format('DD.MM.YYYY') : '-'
              });
              console.log('TABLE DATA', this.tableData);
            }
          });
        } catch (e) {
          console.info(e);
        }
        this.loader = false;
        console.log(this.loader, "LOADER")
      }
    },
    data: () => ({
      loader: true,
      tableData: [],
      divisibility: divisibility,
      sortable: true,
      search,
      search_txt: ''
    })
  };
</script>

<style scoped lang="scss">
  .balance {
    text-align: right;
  }

  .sortable-i {
    width: 42px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;

    i {
      display: block;
      line-height: 8px;
      color: #C0C4CC;

      &.active {
        color: #47C2FF
      }
    }
  }

  .block-header {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .footer-tx {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 40px;
  }
</style>
